import { render } from "./TwoFAInstallPopup.vue?vue&type=template&id=ad8185e2&ts=true"
import script from "./TwoFAInstallPopup.vue?vue&type=script&lang=ts"
export * from "./TwoFAInstallPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__